import { render, staticRenderFns } from "./BotEditBuyLow.vue?vue&type=template&id=655f86f7&"
import script from "./BotEditBuyLow.vue?vue&type=script&lang=js&"
export * from "./BotEditBuyLow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports